import React, { type JSX } from "react";
import { useParams } from "react-router";
import ConversationSummary from "./ConversationSummary";
import ConversationTurnList from "./ConversationTurnList";
import { useConversationDetail } from "./useConversationDetail";

export default function ConversationDetail(): JSX.Element {
  const { conversationId } = useParams<{ conversationId: string }>();
  const { detail, sessions, turns, loading, error } = useConversationDetail(conversationId);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!detail) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-500">Conversation not found.</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <ConversationSummary detail={detail} sessions={sessions} turns={turns} error={error} />
      <ConversationTurnList turns={turns} sessions={sessions} />
    </div>
  );
}
